import { useMemo } from 'react'
import MainTable from 'app/views/components/Table/MainTable'
import {
  ColumnVisibilityUpdater,
  MRT_ColumnVisibilityState,
  PaginationUpdater,
} from 'app/utils/grid-sorting-storage'
import { getFacilityHistoryColumns } from './facility-history-columns'
import FacilityHistoryModifiedFields from './facility-history-modified-fields'
import { FacilityHistoryEntry } from './facility-history-types'

interface Props {
  entries: FacilityHistoryEntry[]
  isLoading: boolean
  pagination: { pageSize: number; pageIndex: number }
  onPaginationChange: (updaterOrValue: PaginationUpdater) => void
  columnVisibility: MRT_ColumnVisibilityState
  onColumnVisibilityChange: (updaterOrValue: ColumnVisibilityUpdater) => void
  onRevert: (entry: FacilityHistoryEntry) => void
  onApproveRevert: (entry: FacilityHistoryEntry) => void
  onRejectRevert: (entry: FacilityHistoryEntry) => void
  pendingRevertId: string | null
}

export default function FacilityHistoryTable({
  entries,
  isLoading,
  pagination,
  onPaginationChange,
  columnVisibility,
  onColumnVisibilityChange,
  onRevert,
  onApproveRevert,
  onRejectRevert,
  pendingRevertId,
}: Props) {
  const columns = useMemo(
    () =>
      getFacilityHistoryColumns({
        onRevert,
        onApproveRevert,
        onRejectRevert,
        pendingRevertId,
      }),
    [onRevert, onApproveRevert, onRejectRevert, pendingRevertId],
  )

  return (
    <MainTable
      tableName="Facility History"
      columnDefs={columns}
      data={entries}
      isLoading={isLoading}
      withPagination
      enableTopToolbar={false}
      headerBackgroundColor="#F0EEEE"
      border
      isAccordionTable
      fromTradeEntry
      setRow={() => { }}
      initialPagination={pagination}
      onPaginationChange={onPaginationChange}
      initialColumnVisibility={columnVisibility}
      onColumnVisibilityChange={onColumnVisibilityChange}
      enableColumnOrdering={false}
      enableColumnResizing={false}
      enableGrouping={false}
      enableColumnFilters={false}
      enableColumnActions={false}
      enableFilters={false}
      enableSorting={false}
      enableFullScreenToggle={false}
      enableDensityToggle={false}
      enableHiding={false}
      renderDetailPanel={({ row }: { row: { original: FacilityHistoryEntry } }) => (
        <FacilityHistoryModifiedFields entry={row.original} />
      )}
    />
  )
}
